import Component from '../abstracts/Component';
import {debounce} from '../utils/ScreenUtils';
import { removeAlgoliaAttributes } from '../utils/algoliaTrackings';

export default class PdpMainComponent extends Component {
  constructor(compEl) {
    super(compEl);
    // this.sizeGuideTriggerList = this.$component.querySelectorAll(this.SELECTORS.sizeGuideTrigger);
    this.goto = this.$component.querySelector(this.SELECTORS.goto);
    this.gallery = this.$component.querySelector(this.SELECTORS.gallery);
    this.skuInfo = this.$component.querySelector(this.SELECTORS.skuInfo);
    this.skuInfoContainer = this.$component.querySelector(this.SELECTORS.skuInfoContainer);
    this.init();
  }

  get SELECTORS() {
    return {
      header: '[data-js-component="HeaderComponent"]',
      wrapper: '[data-wrapper]',
      skuInfo: '[data-info-container]',
      skuInfoContainer: '.js-info-container',
      completeLook: '[data-js-component="CompleteLookComponent"]',
      images: '[data-images]',
      image: '[data-image]',
      sizeGuideTrigger: "[data-js-size-guide]",
      goto: "[data-go-to]",
      gallery: ".js-gallery"
    };
  }

  get CLASSES() {
    return {
      HIDDEN: '--hidden'
    }
  }

  init() {
    if (this.goto) {
      const gotoAnchorSelector = this.goto.querySelector("a").getAttribute("href");
      // if there is target element, show link
      if (document.querySelector(gotoAnchorSelector)) {
        this.goto.classList.remove(this.CLASSES.HIDDEN);
      }
    }
  }

  bindEvents() {
    window.addEventListener("resize", debounce((e) => {
      console.info("--resize completed--");
      this.$emit(this.$customEvents.SCREEN_EVENTS.resize);
    }, 300))
  }

  render() {
    super.render();
    this.bindEvents();
    // If algolia params are stored remove them
    removeAlgoliaAttributes();
  }
}
